import { Loader2 } from 'lucide-react';

/**
 * @param {{ children: import('react').ReactNode, variant?: 'primary' | 'secondary' | 'ghost' | 'danger', className?: string, disabled?: boolean, loading?: boolean, type?: 'button' | 'submit', onClick?: () => void }} props
 */
export function Button({
  children,
  variant = 'primary',
  className = '',
  disabled,
  loading,
  type = 'button',
  onClick,
  ...props
}) {
  const variants = {
    primary:
      'bg-brand text-white shadow-[var(--shadow-sm)] hover:bg-brand-light active:scale-[0.98] active:bg-brand-dark',
    secondary:
      'bg-surface-muted text-text border border-brand/10 hover:bg-surface-card active:scale-[0.98]',
    ghost: 'bg-transparent text-brand hover:bg-brand/10 active:bg-brand/15',
    danger: 'bg-danger text-white shadow-[var(--shadow-sm)] hover:bg-red-700 active:scale-[0.98]',
  };

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={`inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2 font-medium transition-all duration-150 disabled:opacity-50 min-h-[44px] ${variants[variant]} ${className}`}
      {...props}
    >
      {loading ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
          <span>Loading...</span>
        </>
      ) : (
        children
      )}
    </button>
  );
}
